/* eslint-disable @faire/no-text-transform */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { Core } from "@faire/design-tokens";
import { DEPARTMENTS } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/departments";
import { extendedMediaStrings } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/media";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography, TypographyStyles } from "@faire/web--source/slate/Typography";
import styled, { css } from "styled-components";
export var DESIGN_DEPARTMENT = "Design";
export var CUSTOMER_SUPPORT_DEPARTMENT = "Customer Support";
export var SALES_DEPARTMENT = "Sales";
export var horizontalPadding = css([
    "padding-left:32px;padding-right:32px;",
    "{padding-left:72px;padding-right:72px;}",
    "{padding-left:128px;padding-right:128px;}",
    "{padding-left:208px;padding-right:208px;}",
    "{padding-left:184px;padding-right:184px;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.desktop, extendedMediaStrings.xlarge, extendedMediaStrings.extraxlarge);
var verticalPadding = css([
    "padding-top:48px;padding-bottom:48px;",
    "{padding-top:72px;padding-bottom:72px;}",
    "{padding-top:128px;padding-bottom:128px;}"
], responsiveMediaQueries.tablet, responsiveMediaQueries.desktopAndAbove);
export var Section = styled(Column).attrs({
    forwardedAs: "section"
}).withConfig({
    componentId: "sc-39c36bb8-0"
})([
    "position:relative;",
    " ",
    " ",
    ""
], function(props) {
    return props.$backgroundColor ? css([
        "background-color:",
        ";"
    ], props.$backgroundColor) : "";
}, function(props) {
    return props.$withHorizontalPadding ? horizontalPadding : "";
}, function(props) {
    return props.$withVerticalPadding ? verticalPadding : "";
});
export var LimitedSectionContent = styled(Column).withConfig({
    componentId: "sc-39c36bb8-1"
})([
    "width:100%;max-width:1300px;"
]);
export var EyebrowText = styled.label.withConfig({
    componentId: "sc-39c36bb8-2"
})([
    "",
    " font-size:10px;line-height:20px;letter-spacing:2px;font-weight:400;text-transform:uppercase;color:",
    ";",
    "{font-size:13px;letter-spacing:2.5px;}"
], function(param) {
    var theme = param.theme;
    return TypographyStyles({
        theme: theme
    });
}, function(props) {
    var _props_color;
    return (_props_color = props.color) !== null && _props_color !== void 0 ? _props_color : Core.text.subdued;
}, responsiveMediaQueries.tabletAndAbove);
export var SectionHeadline = styled(Typography).attrs({
    variant: "displaySSerifRegular"
}).withConfig({
    componentId: "sc-39c36bb8-3"
})([
    "&&&{",
    " ",
    "{",
    "}}"
], function(param) {
    var theme = param.theme, color = param.color;
    return TypographyStyles({
        variant: "displaySSerifRegular",
        theme: theme,
        color: color
    });
}, responsiveMediaQueries.desktopAndAbove, function(param) {
    var theme = param.theme, color = param.color;
    return TypographyStyles({
        variant: "displayMSerifRegular",
        theme: theme,
        color: color
    });
});
export var DefinitionTerm = styled.dt.withConfig({
    componentId: "sc-39c36bb8-4"
})([
    "",
    " ",
    "{",
    "}"
], function(param) {
    var theme = param.theme;
    return TypographyStyles({
        variant: "subheadingSansMedium",
        theme: theme
    });
}, responsiveMediaQueries.desktopAndAbove, function(param) {
    var theme = param.theme;
    return TypographyStyles({
        variant: "sectionHeaderSansMedium",
        theme: theme
    });
});
export var DefinitionDescription = styled.dd.withConfig({
    componentId: "sc-39c36bb8-5"
})([
    "",
    " ",
    "{",
    "}"
], function(param) {
    var theme = param.theme;
    return TypographyStyles({
        as: "p",
        theme: theme
    });
}, extendedMediaStrings.extraxlarge, function(param) {
    var theme = param.theme;
    return TypographyStyles({
        variant: "subheadingSansMedium",
        theme: theme
    });
});
export var CTAButton = styled(Button).withConfig({
    componentId: "sc-39c36bb8-6"
})([
    "width:fit-content;min-width:220px;"
]);
export var FadingImage = styled.img.withConfig({
    componentId: "sc-39c36bb8-7"
})([
    "opacity:0;transition:opacity 1s;",
    ""
], function(param) {
    var $isActive = param.$isActive;
    return $isActive ? "opacity: 1;" : "";
});
var LOCATION_OVERRIDE = {
    "San Francisco": 1,
    Kitchener: 2
};
var ORDER_OVERRIDE = {
    "Product Design Manager": 1,
    "Product Design Lead": 2,
    "Product Designer": 3,
    "Brand Production Designer": 4,
    "Content Designer": 5,
    "Design Research Manager": 6
};
export var mapDepartmentsWithTieredView = function(data, strictLocalize) {
    var departments = data.filter(function(department) {
        var _department_jobs;
        return (_department_jobs = department.jobs) === null || _department_jobs === void 0 ? void 0 : _department_jobs.length;
    }).map(function(department) {
        var departmentInfo = DEPARTMENTS(strictLocalize)[department.name];
        var _departmentInfo_title;
        department.title = (_departmentInfo_title = departmentInfo === null || departmentInfo === void 0 ? void 0 : departmentInfo.title) !== null && _departmentInfo_title !== void 0 ? _departmentInfo_title : department.name;
        department.parentDepartment = departmentInfo === null || departmentInfo === void 0 ? void 0 : departmentInfo.parentDepartment;
        department.childDepartments = [];
        department.jobs.map(function(job) {
            if (Array.isArray(job.metadata)) {
                var typeMeta = job.metadata.find(function(meta) {
                    return meta.name === "Employment Type";
                });
                if (typeMeta) {
                    job.type = typeMeta.value;
                } else {
                    job.type = "-";
                }
            }
        });
        if (department.name === DESIGN_DEPARTMENT) {
            department.jobs = department.jobs.sort(function(job1, job2) {
                var _LOCATION_OVERRIDE_job1_location_name_trim, _LOCATION_OVERRIDE_job2_location_name_trim;
                var locationPriority = ((_LOCATION_OVERRIDE_job1_location_name_trim = LOCATION_OVERRIDE[job1.location.name.trim()]) !== null && _LOCATION_OVERRIDE_job1_location_name_trim !== void 0 ? _LOCATION_OVERRIDE_job1_location_name_trim : Number.MAX_SAFE_INTEGER) - ((_LOCATION_OVERRIDE_job2_location_name_trim = LOCATION_OVERRIDE[job2.location.name.trim()]) !== null && _LOCATION_OVERRIDE_job2_location_name_trim !== void 0 ? _LOCATION_OVERRIDE_job2_location_name_trim : Number.MAX_SAFE_INTEGER);
                if (locationPriority !== 0) {
                    return locationPriority;
                }
                var _ORDER_OVERRIDE_job1_title_trim, _ORDER_OVERRIDE_job2_title_trim;
                return ((_ORDER_OVERRIDE_job1_title_trim = ORDER_OVERRIDE[job1.title.trim()]) !== null && _ORDER_OVERRIDE_job1_title_trim !== void 0 ? _ORDER_OVERRIDE_job1_title_trim : Number.MAX_SAFE_INTEGER) - ((_ORDER_OVERRIDE_job2_title_trim = ORDER_OVERRIDE[job2.title.trim()]) !== null && _ORDER_OVERRIDE_job2_title_trim !== void 0 ? _ORDER_OVERRIDE_job2_title_trim : Number.MAX_SAFE_INTEGER);
            });
        }
        if (department.parentDepartment === CUSTOMER_SUPPORT_DEPARTMENT) {
            return {
                name: "Customer Support",
                jobs: [],
                title: "Customer Support",
                childDepartments: [
                    department
                ]
            };
        }
        if (department.parentDepartment === SALES_DEPARTMENT) {
            return {
                name: "Sales",
                jobs: [],
                title: "Sales",
                childDepartments: [
                    department
                ]
            };
        }
        return department;
    });
    var departmentRecord = {};
    departments.forEach(function(newDepartment) {
        var currentDepartment = departmentRecord[newDepartment.title];
        if (isNotUndefined(currentDepartment)) {
            departmentRecord[newDepartment.title] = _object_spread_props(_object_spread({}, currentDepartment), {
                childDepartments: _to_consumable_array(currentDepartment.childDepartments).concat(_to_consumable_array(newDepartment.childDepartments))
            });
        } else {
            departmentRecord[newDepartment.title] = _object_spread({}, newDepartment);
        }
    });
    return Object.values(departmentRecord);
};
export var getJobOpeningCount = function(departments) {
    var count = 0;
    departments.forEach(function(department) {
        count += department.jobs.length;
        if (department.childDepartments.length > 0) {
            department.childDepartments.forEach(function(childDepartments) {
                count += childDepartments.jobs.length;
            });
        }
    });
    return count;
};
export var getFilteredDepartmentByLocation = function(departments, selectedLocation) {
    return departments.map(function(department) {
        if (department.childDepartments.length > 0) {
            var filteredChildDepartments = getFilteredDepartmentByLocation(department.childDepartments, selectedLocation);
            if (filteredChildDepartments.length > 0) {
                return _object_spread_props(_object_spread({}, department), {
                    childDepartments: filteredChildDepartments
                });
            }
        }
        var isSelectedLocationDepartment = department.jobs.some(function(job) {
            return job.location.name.includes(selectedLocation);
        });
        if (isSelectedLocationDepartment) {
            var filteredJobs = department.jobs.filter(function(job) {
                return job.location.name.includes(selectedLocation);
            });
            return _object_spread_props(_object_spread({}, department), {
                jobs: filteredJobs
            });
        }
        return undefined;
    }).filter(isNotUndefined);
};
//Location name will be looks like : "New York, NY" or "New York City, NY · San Francisco, CA"
export var getFlattenedLocations = function(locationNames) {
    return locationNames.split(" · ");
};
